<template>
  <div>
    <div class="bg-primary">
      <div class="ml-5 mr-5 pt-4 d-flex flex-column">
        <div class="d-flex align-content-start flex-wrap">
          <h2 class="ml-8 mr-2 mb-5 white--text">Formato de Etiqueta</h2>
        </div>
        <div class="d-flex align-content-start flex-wrap">
          <div class="ml-4 mr-2" style="width: 100%;">
            <v-toolbar class="pl-0" flat color="transparent">
              <v-row justify="start">
                <v-col lg="6">
                  <v-text-field
                    v-model="search"
                    solo
                    prepend-inner-icon="mdi-magnify"
                    label="Buscar"
                    class="searchWidth mt-4"
                  >
                    <v-icon dark>mdi-face-agent</v-icon>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-spacer></v-spacer>
              <v-btn class="button-gray" @click="newFormat">Nuevo</v-btn>
            </v-toolbar>
          </div>
        </div>
      </div>
    </div>
    <div class="margin-top-max">
      <audioFormat class="ml-5 mr-5" :search="search" />
    </div>
  </div>
</template>

<script>
import audioFormat from "../../components/filename-format/filenameFormatTablet";

export default {
  data: () => ({
    search: "",
  }),
  components: {
    audioFormat,
  },
  methods: {
    newFormat() {
      this.$router.push(`/filenameformat/newfilenameformat`);
    },
  },
};
</script>

<style lang="scss">
@import "../../styles/global.scss";
</style>
